import { useContext, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@material-ui/core';

import { DeviceContext } from '@vyce/core/src/contexts';
import { MAIN_CONTAINER_ID } from '@vyce/core/src/constants';
import { AppTextField } from '@vyce/core/src/components/inputs';

interface Props {
  open: boolean;
  handleClose: () => void;
  handleSave: (rates: { basic: string | null; overtime: string | null }) => void;
}
export const RatesToAllShiftsDialog: React.FC<Props> = ({ open, handleClose, handleSave }) => {
  const { isMobile } = useContext(DeviceContext);
  const [rates, setRates] = useState<{ basic: string | null; overtime: string | null }>({
    basic: null,
    overtime: null,
  });

  const onClose = () => {
    setRates({ basic: null, overtime: null });
    handleClose();
  };

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <DialogTitle>Set hourly rates for all shifts</DialogTitle>

      <DialogContent style={{ minWidth: isMobile ? '100%' : 600 }}>
        <DialogContentText>All the currently set rates will get overwritten.</DialogContentText>

        <Box display="flex" gridGap={16}>
          <AppTextField
            fullWidth
            type="number"
            disabled={false}
            label="Basic Hourly Rate (£)"
            onChange={e => setRates({ ...rates, basic: e.target.value })}
            defaultValue={rates.basic || ''}
          />

          <AppTextField
            fullWidth
            type="number"
            disabled={false}
            label="Overtime Hourly Rate (£)"
            onChange={e => setRates({ ...rates, overtime: e.target.value })}
            defaultValue={rates.overtime || ''}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button size="large" onClick={onClose} variant="outlined">
          Close
        </Button>

        <Button
          style={{ width: 140 }}
          onClick={() => {
            handleSave(rates);
            onClose();
          }}
          size="large"
          type="submit"
          color="primary"
          variant="contained"
        >
          Set rates
        </Button>
      </DialogActions>
    </Dialog>
  );
};
